import { CalendarEntryModel } from "@INTEGRATIONS/scheduler/models";

export function resetEvent(eventRecord: CalendarEntryModel): void {
    if (eventRecord.isCreating) {
        eventRecord.remove();
    } else {
        eventRecord.clearChanges();
    }
}
